import apiDefaults from '@/api/defaultConfiguration';
import { DamagecasesApiFactory } from '@/api/generated';
import { emptyCatch, getUnixTimestamp } from '@/plugins/Utils';

export default {
	state: {
		documents: null,
		uploadedNew: false,
	},
	getters: {
		getDocuments(state) {
			return state.documents;
		},
		getUploadedNew(state) {
			return state.uploadedNew;
		},
		getDocumentsRepairShop(state) {
			return state.documents?.filter(document => document.set === 'AppRepairShop');
		},
		getDocumentsCustomer(state) {
			return state.documents?.filter(document => document.set === 'AppCustomer');
		},
		getDocumentsDamageAssessor(state) {
			return state.documents?.filter(document => document.set === 'AppDamageAssessor');
		},
		getDocumentsLawyer(state) {
			return state.documents?.filter(document => document.set === 'AppLawyersOffice');
		},
		getDocumentsMisc(state) {
			return state.documents?.filter(document => document.type === 'misc' && document.uuid);
		},
		getDocumentByType: state => type => state.documents?.find(document => document.type === type && document.uuid),
	},
	mutations: {
		addDocument(state, payload) {
			state.documents.push(payload);
		},
		clearDocuments(state) {
			state.documents = null;
		},
		setUploadNew(state, payload) {
			state.uploadedNew = payload;
		},
		setDocuments(state, payload) {
			state.documents = payload;
			state.documents._ttl = getUnixTimestamp() + 60;
		},
	},
	actions: {
		updateDocuments({ commit, dispatch, getters }, payload) {
			const id = payload?.id || getters.getDamageCase?.id;

			return DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdDocumentsGet(id)
				.then(response => {
					if (response.data) {
						commit('setDocuments', response.data.data);
					}
				})
				.catch(emptyCatch);
		},
	},
};
